import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName/index.js';
export const Label = ({ htmlFor, htmlElement: Tag = 'label', label, placeholder, required, className, showInlineLabel, children, hideLabel, }) => {
    // if react node is passed as label, return it
    if (label && typeof label === 'object') {
        return label;
    }
    return (_jsxs(Tag, { htmlFor: htmlFor, className: constructClassName([
            styles.label,
            className,
            (showInlineLabel || (!label && Boolean(placeholder))) && styles.placeholderLabel,
            showInlineLabel && styles.placeholderLabelVisible,
            hideLabel && styles.hideLabel,
        ]), children: [label || placeholder, required && (_jsx(React.Fragment, { children: _jsxs("span", { className: styles.requiredAsterisk, children: [' ', "*"] }) })), children] }));
};
